var map = {
	"./ash.jpg": "b50c",
	"./clear.jpg": "dcf4",
	"./clear_night.jpg": "e612",
	"./clouds.jpg": "3166",
	"./clouds_night.jpg": "ea4a6",
	"./drizzle.jpg": "de35",
	"./dust.jpg": "89c6",
	"./fog.jpg": "ec7d",
	"./haze.jpg": "0b99",
	"./mist.jpg": "c0d0",
	"./rain.jpg": "5d4c",
	"./sand.jpg": "dbee",
	"./smoke.jpg": "0743",
	"./snow.jpg": "c209",
	"./squall.jpg": "6ca2",
	"./thunderstorm.jpg": "0816",
	"./tornado.jpg": "abf7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8021";